"use client";

import { ReactNode, useEffect } from "react";
import Lenis from "@studio-freight/lenis";

export default function LenisProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    if (typeof window === "undefined") {
      return; // Early return if running on server
    }

    // Check device type from data attribute
    const deviceType = document.body.dataset.deviceType;
    const isMobileDevice = deviceType === "mobile" || deviceType === "tablet";

    // Don't initialize Lenis on mobile devices
    if (isMobileDevice) {
      // Ensure scrolling is enabled on mobile
      document.body.style.overflow = "";
      return;
    }

    const lenis = new Lenis({
      duration: 1.2,
      wheelMultiplier: 1,
      touchMultiplier: 2,
      syncTouch: true,
    });

    // Start with scrolling disabled
    lenis.stop();
    document.body.style.overflow = "hidden";

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    // Enable scrolling after animation
    const timer = setTimeout(() => {
      lenis.start();
    }, 1500);

    return () => {
      clearTimeout(timer);
      lenis.destroy();
      // Reset overflow on cleanup
      document.body.style.overflow = "";
    };
  }, []);

  return <>{children}</>;
}
